<script>
  import SuggestionDropdown from "./suggestionDropdown.svelte"
  export let parsedJson
  export let editorValues
  export let disableBtn
  let activeItem
  let tempJson
</script>

<div class="grid w-4/6 grid-cols-1 gap-2 p-2">
  <SuggestionDropdown bind:disableBtn dropdownItems={Object.keys(parsedJson)} {parsedJson} {activeItem} bind:tempJson {editorValues} />
</div>
